module.exports = __webpack_public_path__ + "static/allmodels-bb02ef16c510483d0a94b4cb1e42f293.jpg";